'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _formFieldUtils = require('../../../common/formFieldUtils');

var _SearchForm = require('../SearchForm');

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _service = require('../../service');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DisplayTable = function (_Component) {
  _inherits(DisplayTable, _Component);

  function DisplayTable(props) {
    _classCallCheck(this, DisplayTable);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onSearchFormReady = function (searchFormInstance) {
      _this.searchFormInstance = searchFormInstance;
    };

    _this.fetchTableData = function (page, count) {
      var _this$state = _this.state,
          current = _this$state.current,
          pageSize = _this$state.pageSize;
      var _this$props = _this.props,
          params = _this$props.params,
          onDisplayTableQuery = _this$props.onDisplayTableQuery;

      var searchParam = _this.searchFormInstance ? _this.searchFormInstance.getData() : null;
      _this.setState({ showMask: true });
      return (0, _service.pageQuery)(params, page || current, count || pageSize, searchParam).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _this.setState({ showMask: false });
        var rowDatas = (res.list || []).map(function (item) {
          var rowData = {};
          try {
            rowData = JSON.parse(item.rowData);
          } catch (e) {}
          return _extends({}, item, rowData, { rowData: rowData });
        });
        _this.setState({
          pageData: {
            data: rowDatas,
            currentPage: res.current,
            totalCount: res.total
          }
        });
        onDisplayTableQuery(res.total);
      }).catch(function (_ref) {
        var success = _ref.success,
            errorMsg = _ref.errorMsg;

        _this.setState({ showMask: false });
        _next.Message.error(errorMsg);
      });
    };

    _this.deleteRows = function () {
      var rowIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var rowKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var params = _this.props.params;

      return (0, _service.batchDelete)(_extends({
        rowIds: rowIds,
        rowKeys: rowKeys
      }, params));
    };

    _this.removeHandler = function (rowId, rowKey) {
      _next.Dialog.confirm({
        title: '确认',
        content: '确认删除该条数据?',
        onOk: function onOk() {
          _this.deleteRows([rowId], [rowKey]).then(function () {
            _next.Message.notice('删除行成功');
            _this.fetchTableData();
          });
        }
      });
    };

    _this.removeSelectedHandler = function () {
      var selectedRows = _this.state.selectedRows;

      if ((0, _lodash.isEmpty)(selectedRows)) {
        return;
      }
      _next.Dialog.confirm({
        title: '确认',
        content: '确认清空选中的所有数据?',
        onOk: function onOk() {
          _this.deleteRows(selectedRows.map(function (item) {
            return item.id;
          }), selectedRows.map(function (item) {
            return item.rowKey;
          })).then(function () {
            _next.Message.notice('删除行成功');
            _this.fetchTableData();
          });
        }
      });
    };

    _this.removeAllHandler = function () {
      var _this$props2 = _this.props,
          params = _this$props2.params,
          onDisplayTableQuery = _this$props2.onDisplayTableQuery;
      // 调用后端删除全部方法，然后重新查询

      _next.Dialog.confirm({
        title: '确认',
        content: '确认清空所有数据?',
        onOk: function onOk() {
          (0, _service.clearTable)({
            sequenceNo: params.sequenceNo,
            matterId: params.matterId,
            tablePropertyId: params.tablePropertyId
          }).then(function () {
            onDisplayTableQuery && onDisplayTableQuery(0);
            _this.setState({ pageData: { data: [], currentPage: 1, totalCount: 0 } });
          });
        }
      });
    };

    _this.searchFormInstance = null;
    _this.state = {
      selectedRows: [],
      pageData: {
        data: [],
        currentPage: 1,
        totalCount: 0
      },
      current: 1,
      pageSize: 10,
      showMask: false
    };
    return _this;
  }

  DisplayTable.prototype.componentDidMount = function componentDidMount() {
    var initCallback = this.props.initCallback;

    initCallback && initCallback(this);
    this.fetchTableData();
  };

  DisplayTable.prototype.getColumns = function getColumns() {
    var _this2 = this;

    var columns = this.props.columns;

    var resultColumns = [].concat(_toConsumableArray(columns));
    resultColumns.push({
      dataIndex: 'action',
      title: '操作',
      width: '6rem',
      lock: 'right',
      cell: function cell(value, index, record) {
        return _react2.default.createElement(
          _next.Button,
          { text: true, onClick: function onClick() {
              return _this2.removeHandler(record.id, record.rowKey);
            } },
          '删除'
        );
      }
    });
    return resultColumns.map(function (item) {
      return _react2.default.createElement(_next.Table.Column, item);
    });
  };

  DisplayTable.prototype.renderBottomBar = function renderBottomBar() {
    var _state = this.state,
        selectedRows = _state.selectedRows,
        deleteAllMask = _state.deleteAllMask,
        deleteSelectMask = _state.deleteSelectMask;

    var selectedCount = (0, _lodash.isEmpty)(selectedRows) ? 0 : selectedRows.length;
    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-display-table-bar' },
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(
          _next.Button,
          { onClick: this.removeAllHandler, loading: deleteAllMask },
          '\u5168\u90E8\u6E05\u9664'
        )
      ),
      _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(
          _next.Button,
          { onClick: this.removeSelectedHandler, disabled: selectedCount === 0, loading: deleteSelectMask },
          '\u5220\u9664 (',
          selectedCount,
          ')'
        )
      )
    );
  };

  DisplayTable.prototype.renderSearchForm = function renderSearchForm() {
    var searchFormProps = this.props.searchFormProps;

    return _react2.default.createElement(_SearchForm2.default, _extends({}, searchFormProps, {
      formKey: (0, _formFieldUtils.uuid)(),
      searchHandler: this.fetchTableData.bind(this),
      initCallback: this.onSearchFormReady
    }));
  };

  DisplayTable.prototype.renderTable = function renderTable() {
    var _this3 = this;

    var rowSelector = this.props.rowSelector;
    var _state2 = this.state,
        showMask = _state2.showMask,
        pageSize = _state2.pageSize,
        pageData = _state2.pageData;

    var columns = this.getColumns();

    var rowSelection = {
      onSelect: function onSelect(selected, record, selectedRows) {
        _this3.setState({ selectedRows: selectedRows });
      },
      onSelectAll: function onSelectAll(selected, selectedRows) {
        _this3.setState({ selectedRows: selectedRows });
      }
    };

    var onPagerChange = function onPagerChange(current) {
      _this3.setState({ current: current }, function () {
        _this3.fetchTableData();
      });
    };

    var onPageSizeChange = function onPageSizeChange(pageSize) {
      _this3.setState({ current: 1, pageSize: pageSize }, function () {
        _this3.fetchTableData();
      });
    };

    var renderProps = {
      fixedHeader: true,
      maxBodyHeight: 400,
      dataSource: pageData.data,
      primaryKey: 'rowKey',
      rowSelection: rowSelection,
      loading: showMask,
      rowSelector: rowSelector
    };

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _next.Table,
        renderProps,
        columns
      ),
      _react2.default.createElement(_next.Pagination, {
        style: { marginTop: '10px', textAlign: 'right' },
        pageSizeSelector: 'filter',
        popupProps: { align: 'bl tl' },
        pageSizePosition: 'end',
        pageSize: pageSize,
        onChange: onPagerChange,
        current: pageData.currentPage,
        total: pageData.totalCount,
        onPageSizeChange: onPageSizeChange
      })
    );
  };

  DisplayTable.prototype.render = function render() {
    var enableSearch = this.props.enableSearch;

    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-display-table' },
      enableSearch && this.renderSearchForm(),
      this.renderTable(),
      this.renderBottomBar()
    );
  };

  return DisplayTable;
}(_react.Component);

exports.default = DisplayTable;
module.exports = exports['default'];